// @ts-check
import React from "react"
import {
  formatLocalizedDateParts,
  getDateDDMMYYY,
} from "../../../utils/date.utils"
import { renderDayOffIcon } from "../../../utils/vacation.utils"

/**
 * @param {import("./GroupedDateCell.molecule.types").GroupedDateCellProps} props
 * @returns
 */
export function GroupedDateCell(props) {
  const { ctx } = props
  const { row } = ctx

  const { weekday } = formatLocalizedDateParts(row.groupingValue)
  const formattedDate = getDateDDMMYYY(row.groupingValue)

  return (
    <div className="flex align-items-center z-1 pl-2 pr-2 subheader-date-cell white-space-nowrap">
      <div style={{ marginRight: "10px" }}>
        {renderDayOffIcon({
          rowData: row.original,
        })}
      </div>

      <span>
        <strong>{weekday}</strong> {formattedDate}
      </span>
    </div>
  )
}
